import { useServiceType } from '.';

export enum ServiceType {
  PICKUP = 'PICKUP',
  CURBSIDE = 'CURBSIDE',
  DINE_IN = 'DINE_IN',
  DELIVERY = 'DELIVERY'
}

export type ServiceTypeLabel = {
  name: string;
  label: string;
};

export type ServiceTypeData = {
  isContactlessDelivery?: boolean;
  tableUuid?: string | string[];
  employeeUuid?: string | string[];
  note?: string | undefined;
};

export type Service = {
  serviceType?: string;
};

export type ServiceTypeState = ReturnType<typeof useServiceType>;
